import { render, staticRenderFns } from "./DropdownButton.vue?vue&type=template&id=054e695a&scoped=true"
import script from "./DropdownButton.vue?vue&type=script&lang=js"
export * from "./DropdownButton.vue?vue&type=script&lang=js"
import style0 from "./DropdownButton.vue?vue&type=style&index=0&id=054e695a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054e695a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('054e695a')) {
      api.createRecord('054e695a', component.options)
    } else {
      api.reload('054e695a', component.options)
    }
    module.hot.accept("./DropdownButton.vue?vue&type=template&id=054e695a&scoped=true", function () {
      api.rerender('054e695a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DropdownButton.vue"
export default component.exports